export default __webpack_public_path__ + "static/media/mica.690b7734.png";